module.exports = __webpack_public_path__ + "media/es_slide24_audio.1f61c613.mp4";